import React, {useContext, useEffect} from "react";
import PageTemplate from "../components/PageTemplate";
import BuildHeaderMobile from "../components/build/BuildHeaderMobile";
import BuildBody from "../components/build/BuildBody";

const Build = () => {
  return (
    <PageTemplate
      title="Build"
      mobileHeader={<BuildHeaderMobile/>}
      sidebarTitle={`Build Spotlight`}
      sidebarSubtitle="Let's take it step by step"
      centered
      fullWidth
    >
      <BuildBody/>
    </PageTemplate>
  );
};

export default Build;
